import React, { useState } from 'react';
import PropTypes from 'prop-types';
import css from './ReservationPopUpCoach.scss';
import { CATEGORY_ID } from 'Constants/categories';
import { FormattedMessage as Translation, injectIntl } from 'react-intl';
import { compose } from 'redux';

const tutorial = [
    {
        step: 1,
        description: <Translation id="bookingTutorialStep1" defaultMessage="Booking produk ini hanya dengan" />

    },
    {
        step: 2,
        description: <Translation id="bookingTutorialStep2" defaultMessage="Segera booking dan jadi yang pertama miliki produk ini" />
    },
    {
        step: 3,
        description: <Translation id="bookingTutorialStep3" defaultMessage="Biaya bookingmu bisa kembali 100%. Segera booking sebelum kehabisan produknya!" />

    }
];

const PopUpReservationCoach = props => {
    const { onClose, categoryId } = props;
    const [pagination, setPagination] = useState(0);

    const handleNext = () => {
        // eslint-disable-next-line no-magic-numbers
        if (pagination === 2) {
            onClose();
            setPagination(0);
        }
        else {
            setPagination(pagination + 1);
        }
    };

    const priceCategory = categoryId === CATEGORY_ID.USED_CAR
        ? <Translation id="bookingPriceForCar" defaultMessage="Rp1.000.000" />
        : <Translation id="defaultbookingPrice" defaultMessage="Rp500.000" />;

    return (
        <div className={ css.container } data-aut-id="onBoardingPopUp">
            <div className={ css.instruction }>&quot;{tutorial[pagination].description} {pagination === 0 && <strong>{priceCategory}</strong>}&quot;</div>
            <div className={ css.controlPopUp }>
                <div>{tutorial[pagination].step}/{tutorial.length}</div>
                {pagination === 2
                    ? <div className={ css.buttonContainer }>
                        <div className={ css.skip }
                            onClick={ onClose }
                            data-aut-id="onBoardingPopUpBtnClose"
                            role="button"
                            tabIndex={ 0 }>
                            <Translation id="close" />
                        </div>
                    </div>
                    : <div className={ css.buttonContainer }>
                        <div className={ css.skip }
                            onClick={ onClose }
                            data-aut-id="onBoardingPopUpBtnSkip"
                            role="button"
                            tabIndex={ 0 }>
                            <Translation id="contact_me_skip_button" />
                        </div>
                        <div className={ css.next }
                            onClick={ handleNext }
                            data-aut-id="onBoardingPopUpBtnNext"
                            role="button"
                            tabIndex={ 0 }>
                            <Translation id="plateNext" />
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

PopUpReservationCoach.propTypes = {
    onClose: PropTypes.func,
    categoryId: PropTypes.string
};

export default compose(injectIntl)(PopUpReservationCoach);
